import React from 'react'
import { Link } from 'gatsby'

const Navigation = () => (
  <nav>
    <ul>
      <li><Link to="/about/" activeClassName="active">About</Link></li>
      <li><Link to="/career/" activeClassName="active">Career</Link></li>
      <li><Link to="/recommendations/" activeClassName="active">Recommendations</Link></li>
      <li><Link to="/contact" activeClassName="active">Contact</Link></li>
    </ul>
  </nav>
)

export default Navigation
